module.exports = __webpack_public_path__ + "static/media/spectator-safety-yellow.7bcf56ae.png";